import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useClientStore } from '../stores/client'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/tickets',
    name: 'Tickets',
    component: () => import('../views/Tickets.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tickets/:id',
    name: 'TicketDetail',
    component: () => import('../views/TicketDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/results',
    name: 'Results',
    component: () => import('../views/Results.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/prizes',
    name: 'Prizes',
    component: () => import('../views/PrizeClaim.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('../views/Unauthorized.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/bet',
    name: 'Bet',
    component: () => import('../views/BetFlow.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: 'modality'
      },
      {
        path: 'modality',
        name: 'BetModality',
        component: () => import('../views/bet/ModalityStep.vue')
      },
      {
        path: 'numbers',
        name: 'BetNumbers',
        component: () => import('../views/bet/NumbersStep.vue')
      },
      {
        path: 'placing',
        name: 'BetPlacing',
        component: () => import('../views/bet/PlacingStep.vue')
      },
      {
        path: 'placing-parameters',
        name: 'BetPlacingParameters',
        component: () => import('../views/bet/PlacingParametersStep.vue')
      },
      {
        path: 'numbers-combinatorial',
        name: 'BetNumbersCombinatorial',
        component: () => import('../views/bet/NumbersCombinatorialStep.vue')
      },
      {
        path: 'value',
        name: 'BetValue',
        component: () => import('../views/bet/ValueStep.vue')
      },
      {
        path: 'confirm',
        name: 'BetConfirm',
        component: () => import('../views/bet/ConfirmStep.vue')
      },
      {
        path: 'date',
        name: 'BetDate',
        component: () => import('../views/bet/DateStep.vue')
      },
      {
        path: 'preview',
        name: 'BetPreview',
        component: () => import('../views/bet/PreviewStep.vue')
      }
    ]
  }
]

// Configurar base path para raiz
const base = '/'

const router = createRouter({
  history: createWebHistory(base),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const clientStore = useClientStore()
  
  // Inicializar stores apenas uma vez
  if (!authStore.initialized) {
    authStore.initialize()
  }
  if (!clientStore.initialized) {
    clientStore.initialize()
  }
  
  const isAuthenticated = authStore.isAuthenticated || clientStore.isAuthenticated
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' })
  } else if ((to.name === 'Login' || to.name === 'Register') && isAuthenticated) {
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router

